module.exports = __webpack_public_path__ + "static/img/IMG_20160101_162645.5e6ab59a.jpg";